import { render, staticRenderFns } from "./edit-course-score-modal.vue?vue&type=template&id=2efb0d8b"
import script from "./edit-course-score-modal.vue?vue&type=script&lang=js"
export * from "./edit-course-score-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports